import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "8",
    y: "8",
    width: "10",
    height: "10",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "8",
    y: "8",
    width: "10",
    height: "10",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    title: "Ввод",
    "is-center": true,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('intro'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('subtitle'))
        }, _toDisplayString(_ctx.$t(
            "Переведите средства на этот адрес — баланс обновится после зачисления"
          )), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('tabs')),
          role: "tablist"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.b('tab')),
            role: "tab",
            "aria-selected": false,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFiatDeposit && _ctx.openFiatDeposit(...args)))
          }, " Fiat ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.b('tab', { active: true })),
            role: "tab",
            "aria-selected": true
          }, " Crypto ", 2)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('fields'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('field'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, _toDisplayString(_ctx.$t("Монета")), 3),
            _createVNode(_component_SharedSelect, {
              view: "light",
              options: _ctx.displayedCurrencyOptions,
              value: _ctx.coinId,
              "onUpdate:value": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.coinId) = $event)),
                _ctx.loadChains
              ],
              isCryptoIcon: true,
              icon: _ctx.displayedCurrencyIcon
            }, null, 8, ["options", "value", "icon", "onUpdate:value"])
          ], 2),
          (_ctx.chains.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('field-label'))
                }, _toDisplayString(_ctx.$t("Выберите сеть")), 3),
                _createVNode(_component_SharedSelect, {
                  view: "light",
                  options: _ctx.displayedChainOptions,
                  value: _ctx.chain,
                  "onUpdate:value": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chain) = $event)),
                    _ctx.getDepositAddress
                  ]
                }, null, 8, ["options", "value", "onUpdate:value"])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.address?.addressDeposit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('field-label'))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Адрес кошелька")) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.b('copy-btn')),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyAddressToCliboard && _ctx.copyAddressToCliboard(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("копировать")) + " ", 1),
                    _hoisted_1
                  ], 2)
                ], 2),
                _createElementVNode("p", null, _toDisplayString(_ctx.address.addressDeposit), 1)
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.address?.tagDeposit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(_ctx.b('field'))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('field-label'))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Адрес тэг кошелька")) + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.b('copy-btn')),
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyTagToCliboard && _ctx.copyTagToCliboard(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("копировать")) + " ", 1),
                    _hoisted_2
                  ], 2)
                ], 2),
                _createElementVNode("p", null, _toDisplayString(_ctx.address.tagDeposit), 1)
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["onClose"]))
}